import { Calendar } from "primereact/calendar";
import { Form } from "react-bootstrap";
import { Dropdown } from "primereact/dropdown";

const filterTextTemplate = (options: any) => {
  const filterEventId = JSON.parse(sessionStorage.getItem("eventReportId") || "{}")
  const filterSiteName = JSON.parse(sessionStorage.getItem("siteName") || "{}")
  const filterSub = JSON.parse(sessionStorage.getItem("subCategory") || "{}")
  const filterService = JSON.parse(sessionStorage.getItem("serviceLine") || "{}")

  var result = options.field.replace(/([A-Z])/g, " $1");
  var finalResult = result.charAt(0).toUpperCase() + result.slice(1);

  if (finalResult === "Attachment Name") finalResult = "File Name";
  else if (finalResult === "Analysis") finalResult = "Type";
  return (
    <>
      <div _ngcontent-iir-c84="" className="p-px-3 p-pt-3 p-pb-0 p-left">
        <span _ngcontent-iir-c84="" className="p-text-bold">
          {finalResult}
        </span>
      </div>
      <div className="p-column-filter-constraints ">
        <div className="p-column-filter-constraint ">
          <input
            type="text"
            className="p-inputtext p-component p-element"
            value={options.value}
            onChange={(e: any) =>
              {
                // sessionStorage.setItem(options.field, JSON.stringify(e.target.value))
                options.filterCallback(e.target.value, options.index)
              }
            }
            onKeyDown ={(f:any) =>{
              if(f.key === "Enter"){
                options.filterApplyCallback(options.value, options.index)
                document.getElementById('siteLogo')?.click();
              }
            }}
          />
        </div>
      </div>
    </>
  );
};
const filterDropdownTemplate = (
  options: any,
  filterOptions: any,
  dropDownName: any,
  dropDownValue: any
) => {
  const filterGender = JSON.parse(sessionStorage.getItem("gender") || "{}")
  const filterAge = JSON.parse(sessionStorage.getItem("age") || "{}")
  const filterAgeUnit = JSON.parse(sessionStorage.getItem("ageUnit") || "{}")
  const filterStatus = JSON.parse(sessionStorage.getItem("status") || "{}")
  const filterReviewStatus = JSON.parse(sessionStorage.getItem("reviewStatus") || "{}")
  const filterRegion = JSON.parse(sessionStorage.getItem("region") || "{}")
  var result = options.field.replace(/([A-Z])/g, " $1");
  var finalResult = result.charAt(0).toUpperCase() + result.slice(1);
  if(filterGender !== null && finalResult === "Gender"){
    if(options.value === "null"){
      sessionStorage.setItem("gender",JSON.stringify(""))
      options.value = "null"
    }
    if(filterGender === ""){
      options.value = "null"
    }
  }
  if(filterAgeUnit !== null && finalResult === "Age Unit"){
    if(options.value === "null"){
      sessionStorage.setItem("ageUnit",JSON.stringify(""))
      options.value = "null"
    }
    if(filterAgeUnit === ""){
      options.value = "null"
    }
  }
  if(filterReviewStatus !== null && finalResult === "Review Status"){
    if(options.value === "null"){
      sessionStorage.setItem("reviewStatus",JSON.stringify(""))
      options.value = "null"
    }
    if(filterReviewStatus === ""){
      options.value = "null"
    }
  }

  if (finalResult === "Attachment Name") finalResult = "File Name";
  else if (finalResult === "Analysis") finalResult = "Type";
  return (
    <>
      <div _ngcontent-iir-c84="" className="p-px-3 p-pt-3 p-pb-0 p-left">
        <span _ngcontent-iir-c84="" className="p-text-bold">
          {finalResult}
        </span>
      </div>
      <div className="p-column-filter-constraints ">
        <div className="p-column-filter-constraint pe-2 ps-2">
          <Dropdown
            style={{ width: "100%", textAlign: "left" }}
            value={options.value}
            options={filterOptions}
            optionLabel={dropDownName}
            optionValue={dropDownValue}
            className="p-component p-element"
            onChange={(e: any) =>{
              // sessionStorage.setItem(options.field, JSON.stringify(e.target.value))
              options.filterCallback(e.target.value, options.index)
            }
            }
          />
        </div>
      </div>
    </>
  );
};
const filterGenderTemplate = (options: any) => {
  var result = options.field.replace(/([A-Z])/g, " $1");
  var finalResult = result.charAt(0).toUpperCase() + result.slice(1);
  if (finalResult === "Attachment Name") finalResult = "File Name";
  else if (finalResult === "Analysis") finalResult = "Type";
  return (
    <>
      <div _ngcontent-iir-c84="" className="p-px-3 p-pt-3 p-pb-0 p-left">
        <span _ngcontent-iir-c84="" className="p-text-bold">
          {finalResult}
        </span>
      </div>
      <div className="p-column-filter-constraints ">
        <div className="p-column-filter-constraint ">
          <Form.Group className="mt-1">
            <Form.Check
              inline
              type="radio"
              label="&nbsp;&nbsp;Male"
              name="analysisType"
              onChange={(e: any) =>
                options.filterCallback(e.target.value, options.index)
              }
              checked={options.value === "Male" ? true : false}
              value="Male"
            />
            <Form.Check
              inline
              type="radio"
              label="&nbsp;&nbsp;Female"
              onChange={(e: any) =>
                options.filterCallback(e.target.value, options.index)
              }
              checked={options.value === "Female" ? true : false}
              value="Female"
            />
          </Form.Group>
        </div>
      </div>
    </>
  );
};
const filterAgeUnitTemplate = (options: any) => {
  var result = options.field.replace(/([A-Z])/g, " $1");
  var finalResult = result.charAt(0).toUpperCase() + result.slice(1);
  if (finalResult === "Attachment Name") finalResult = "File Name";
  else if (finalResult === "Analysis") finalResult = "Type";
  return (
    <>
      <div _ngcontent-iir-c84="" className="p-px-3 p-pt-3 p-pb-0 p-left">
        <span _ngcontent-iir-c84="" className="p-text-bold">
          {finalResult}
        </span>
      </div>
      <div className="p-column-filter-constraints ">
        <div className="p-column-filter-constraint ">
          <Form.Group className="mt-1">
            <Form.Check
              inline
              type="radio"
              label="&nbsp;&nbsp;Months"
              name="analysisType"
              onChange={(e: any) =>
                options.filterCallback(e.target.value, options.index)
              }
              checked={options.value === "Months" ? true : false}
              value="Months"
            />
            <Form.Check
              inline
              type="radio"
              label="&nbsp;&nbsp;Year"
              onChange={(e: any) =>
                options.filterCallback(e.target.value, options.index)
              }
              checked={options.value === "Year" ? true : false}
              value="Year"
            />
          </Form.Group>
        </div>
      </div>
    </>
  );
};

const getFormattedDate = (date: Date) => {
  let year = date.getFullYear();
  let month = (1 + date.getMonth()).toString().padStart(2, '0');
  let day = date.getDate().toString().padStart(2, '0');
  return month + '/' + day + '/' + year;
}

const filterDateTemplate = (options: any) => {
  // var From;
  // var To;
  // if(options.value!== null){
  //   if(options.value.slice(-1) === "a"){
  //     From = options.value.slice(0,-1)
  //     dateValues.push(From)
  //   } else if(options.value.slice(-1) === "b"){
  //     To = options.value.slice(0,-1)
  //     dateValues.push(To)
  //   }
  // }
  var finalResult = options.field.toUpperCase();
  let conCatDate = options.value;
  var arrayDOS = [];
  var startDate: Date | undefined;
  var endDate: Date | undefined;
  var startString: string;
  var endString: string;

  if (conCatDate) {
    arrayDOS = conCatDate.split(':');
    if (arrayDOS[0]) {
      startString = arrayDOS[0]
      startDate = new Date(arrayDOS[0]);
    }
    if (arrayDOS[1] !== "undefined") {
      endDate = new Date(arrayDOS[1]);
      endString = arrayDOS[1];
    }
  }

  const GetMaxDate = () => {
    var dt = new Date();
    dt.setTime(dt.getTime() + dt.getTimezoneOffset() * 60 * 1000);
    var offset = -240; //Timezone offset for EST in minutes.
    var estDate = new Date(dt.getTime() + offset * 60 * 1000);
    return estDate;
  };

  return (
    <>
      <div _ngcontent-iir-c84="" className="p-px-3 p-pt-3 p-pb-0 p-left">
        <span _ngcontent-iir-c84="" className="p-text-bold">
          {finalResult}
        </span>
      </div>
      <div className="calendertextbox">
        <Calendar
          readOnlyInput
          style={{ width: "100%" }}
          value={startDate}
          onChange={(e: any) =>{
            let startSt = getFormattedDate(e.target.value);
            // sessionStorage.setItem(options.field, startSt + ':' + endString)
            options.filterCallback(startSt + ':' + endString, options.index)
          }           
          }
          dateFormat="mm/dd/yy"
          placeholder="From Date"
          className="calender-custom"
          showIcon
          maxDate={(endDate === undefined) ? GetMaxDate() : endDate}
        />
      </div>&nbsp;
      <div className="calendertextbox">
        <Calendar
          readOnlyInput
          style={{ width: "100%" }}
          value={endDate}
          onChange={(e: any) =>
            {
              let endSt = getFormattedDate(e.target.value)
              // sessionStorage.setItem(options.field, startString + ':' + endSt)
              options.filterCallback(startString + ':' + endSt, options.index)
            }
          }
          dateFormat="mm/dd/yy"
          placeholder="To Date"
          className="calender-custom"
          showIcon
          minDate={startDate}
          maxDate = {GetMaxDate()}
        />
      </div>
    </>
  );
};

export {
  filterTextTemplate,
  filterDateTemplate,
  filterGenderTemplate,
  filterAgeUnitTemplate,
  filterDropdownTemplate,
};
